import { getClientEnv } from "@shared/env";
import axios from "axios";

const env = getClientEnv();

/**
 * ⚠️⚠️ **ATAYLAB `apiClient` EMAS — interceptor'siz alohida instance.**
 *
 * `app/api/client.ts` ning javob interceptor'i HAR 401 da single-flight
 * refresh'ni ishga tushiradi va u ham yiqilsa `logout()` qilib
 * `window.location.href = "/login"` yozadi. `/login` sahifasi bu tuzoqdan
 * `pathname !== "/login"` sharti bilan qutuladi, `/delete-account` esa
 * QUTULMAYDI: noto'g'ri parol kiritgan foydalanuvchi xato xabarini
 * ko'rish o'rniga login sahifasiga otib yuborilardi va ochiq sahifadan
 * butunlay chiqib ketardi.
 *
 * Bu marshrut token bilan ishlamaydi — kimlik tanadagi telefon + parol
 * orqali isbotlanadi, ya'ni Authorization sarlavhasi ham, refresh cookie
 * ham kerak emas (`withCredentials` yo'q).
 */
const publicClient = axios.create({
	baseURL: `${env.VITE_API_URL}/api/v1`,
	headers: { "Content-Type": "application/json" },
});

export interface AccountDeletionRequest {
	phone: string;
	password: string;
}

interface AccountDeletionResponse {
	success: true;
	data: { message: string };
}

export const accountDeletionService = {
	async request(data: AccountDeletionRequest): Promise<string> {
		const response = await publicClient.post<AccountDeletionResponse>(
			"/account-deletion-requests",
			data
		);

		return response.data.data.message;
	},
};
